RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const Alerts = apps.Alerts = window.createMarionetteApp();
    Alerts.name = 'Alerts';
});
